<form [formGroup]="additionalLoanDetailsForm">
  <fieldset class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_loan_required_day')">
    <legend>Date loan required</legend>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col pr-0">
            <label for="tad_loan_required_day" class="visually-hidden">Day (DD)</label>
            <input type="number" [ngClass]="setDynamicClasses('tad_loan_required_day')" formControlName="tad_loan_required_day" class="form-control" id="tad_loan_required_day" placeholder="DD" min="1" max="31">
          </div>
          <div class="col fpx-5">
            <label for="tad_loan_required_day" class="visually-hidden">Day (DD)</label>
            <input type="number" [ngClass]="setDynamicClasses('tad_loan_required_month')" formControlName="tad_loan_required_month" class="form-control" id="tad_loan_required_month" placeholder="MM" min="1" max="12">
          </div>
          <div class="col pl-0">
            <label for="tad_loan_required_year" class="visually-hidden">Year (YYYY)</label>
            <input type="number" [ngClass]="setDynamicClasses('tad_loan_required_year')" formControlName="tad_loan_required_year" class="form-control" id="tad_loan_required_year" placeholder="YYYY" min="2017" max="2050">
          </div>
        </div>
        <together-auction-dip-validate-fields [displayError]="additionalLoanDetailsForm.hasError('dateInvalid')" errorMsg="Please ensure you enter a valid date."></together-auction-dip-validate-fields>
        <together-auction-dip-validate-fields [displayError]="additionalLoanDetailsForm.get('tad_loan_required_year').touched && additionalLoanDetailsForm.get('tad_loan_required_year').errors?.required" errorMsg="We need to know what date this loan is required."></together-auction-dip-validate-fields>
        @if (additionalLoanDetailsForm.hasError('tooFarInPast')) {
          <div class="d-flex invalid-feedback">
            Date loan required must be a future date.
          </div>
        }
        @if (additionalLoanDetailsForm.hasError('tooFarInFuture')) {
          <div class="d-flex invalid-feedback">
            Unfortunately, we cannot provide finance more than 3 months in the future.
          </div>
        }
      </div>
    </div>
  </fieldset>
  <fieldset class="form-group">
    <div class="row">
      <div class="col-12 col-md-6">
        <label for="tad_property_value">What's the purchase price for the property?</label>
        <div class="form-group c-input--pound" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_property_value').invalid && (additionalLoanDetailsForm.get('tad_property_value').dirty && additionalLoanDetailsForm.get('tad_property_value').touched)}">
          <div class="d-flex">
            <div class="w-80">
              <div class="input-group" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_property_value').invalid && (additionalLoanDetailsForm.get('tad_property_value').dirty && additionalLoanDetailsForm.get('tad_property_value').touched),'is-valid':additionalLoanDetailsForm.get('tad_property_value').valid}">
                <span class="input-group-addon" id="pound-addon">&pound;</span>
                <input type="number" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_property_value').invalid, 'is-valid':additionalLoanDetailsForm.get('tad_property_value').valid}" class="form-control" formControlName="tad_property_value" aria-describedby="pound-addon"
                  id="tad_property_value" required>
                </div>
              </div>
              <div class="w-20 text-right">
                <together-auction-dip-tooltip [placement]="'top'" [title]="'The guide price for a property listed is an indication given by the Auctioneer. Your maximum purchase price, which is the most you’re willing to bid up to for the property, may be higher.'"></together-auction-dip-tooltip>
              </div>
            </div>
            @if (additionalLoanDetailsForm.get('tad_property_value').invalid && additionalLoanDetailsForm.get('tad_property_value').errors?.required && additionalLoanDetailsForm.get('tad_property_value').invalid && additionalLoanDetailsForm.get('tad_property_value').touched) {
              <div class="d-flex invalid-feedback">
                We need to know the maximum purchase price.
              </div>
            }
            @if (additionalLoanDetailsForm.get('tad_property_value').invalid && additionalLoanDetailsForm.get('tad_property_value').errors.minlength && additionalLoanDetailsForm.get('tad_property_value').invalid && additionalLoanDetailsForm.get('tad_property_value').touched) {
              <div class="d-flex invalid-feedback">
                Please enter the full valuation of your property.
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <label for="tab_loan_amount">How much do you want to borrow?</label>
          <div class=" c-input--pound" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_loan_amount').invalid && (additionalLoanDetailsForm.get('tad_loan_amount').dirty && additionalLoanDetailsForm.get('tad_loan_amount').touched)}">
            <div class="d-flex">
              <div class="w-80">
                <div class="input-group" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_loan_amount').invalid && (additionalLoanDetailsForm.get('tad_loan_amount').dirty && additionalLoanDetailsForm.get('tad_loan_amount').touched),'is-valid':additionalLoanDetailsForm.get('tad_loan_amount').valid}">
                  <span class="input-group-addon" id="pound-addon">&pound;</span>
                  <input type="number" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_loan_amount').invalid, 'is-valid':additionalLoanDetailsForm.get('tad_loan_amount').valid}" formControlName="tad_loan_amount" class="form-control" maxlength="7" minlength="5"
                    aria-describedby="pound-addon" id="tad_loan_amount">
                  </div>
                </div>
              </div>
              @if (additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').errors.required && additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').touched) {
                <div class="d-flex invalid-feedback">
                  We need to know how much you want to borrow.
                </div>
              }
              @if (additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').errors.min && additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').touched) {
                <div class="d-flex invalid-feedback">
                  Sorry, we can't provide loans for less than £26,000.
                </div>
              }
              @if (additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').errors.max && additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.get('tad_loan_amount').touched) {
                <div class="d-flex invalid-feedback">
                  Sorry, we can't provide loans over £3000000.
                </div>
              }
              @if (additionalLoanDetailsForm.get('tad_loan_amount').invalid && additionalLoanDetailsForm.hasError('loanValueLess') && (additionalLoanDetailsForm.get('tad_loan_amount').dirty || additionalLoanDetailsForm.get('tad_loan_amount').touched) && (additionalLoanDetailsForm.get('tad_property_value').dirty || additionalLoanDetailsForm.get('tad_property_value').touched)) {
                <div class="d-flex invalid-feedback">
                  This must be less than the estimated or actual price.
                </div>
              }
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group" [ngClass]="{'is-invalid': additionalLoanDetailsForm.get('tad_loan_intended_repayment').invalid && additionalLoanDetailsForm.get('tad_loan_intended_repayment').errors?.required && additionalLoanDetailsForm.get('tad_loan_intended_repayment').invalid && additionalLoanDetailsForm.get('tad_loan_intended_repayment').touched}">
        <div class="row">
          <div class="col-12 col-md-6">
            <legend>How are you going to repay the outstanding balance at the end of your term?</legend>
            <div class="c-radio--list custom-controls-stacked">
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="tad_loan_intended_payment" formControlName="tad_loan_intended_repayment" value="8" name="tad_loan_intended_repayment" [checked]="tad_loan_intended_repayment.value == 8" type="radio" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Property sale</span>
                </label>
              </span>
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="tad_loan_intended_payment" formControlName="tad_loan_intended_repayment" value="11" name="tad_loan_intended_repayment" [checked]="tad_loan_intended_repayment.value == 11" type="radio" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Remortgage</span>
                </label>
              </span>
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="tad_loan_intended_payment" formControlName="tad_loan_intended_repayment" value="7" name="tad_loan_intended_repayment" [checked]="tad_loan_intended_repayment.value == 7" type="radio" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Other</span>
                </label>
              </span>
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="tad_loan_intended_payment" formControlName="tad_loan_intended_repayment" value="12" name="tad_loan_intended_repayment" [checked]="tad_loan_intended_repayment.value == 12" type="radio" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Pension lump sum or similar</span>
                </label>
              </span>
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="tad_loan_intended_payment" formControlName="tad_loan_intended_repayment" value="13" name="tad_loan_intended_repayment" [checked]="tad_loan_intended_repayment.value == 13" type="radio" class="custom-control-input">
                  <span class="custom-control-indicator"></span>
                  <span class="custom-control-description">Inheritance</span>
                </label>
              </span>
            </div>
            @if (additionalLoanDetailsForm.get('tad_loan_intended_repayment').invalid && additionalLoanDetailsForm.get('tad_loan_intended_repayment').errors?.required && additionalLoanDetailsForm.get('tad_loan_intended_repayment').invalid && additionalLoanDetailsForm.get('tad_loan_intended_repayment').touched) {
              <div class="d-flex invalid-feedback">
                We need to know how you're going to repay the outstanding balance at the end of your term.
              </div>
            }
          </div>
        </div>
      </fieldset>
      <fieldset class="form-group">
        <div class="row">
          <div class="col-12 col-md-6">
            <legend>Are you providing another property as additional security?</legend>
            <div class="d-flex">
              <div class="w-40 mr-1">
                <div class="c-radio--separated">
                  <span class="c-radio-button">
                    <input type="radio" name="tad_additional_securities_display" formControlName="tad_additional_securities_display" [checked]="_showAction == true" id="tad_yes" value="true">
                    <label class="c-radio-button__label" for="tad_yes">
                      <span class="c-radio-button__faux">Yes</span>
                      <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                    </label>
                  </span>
                </div>
              </div>
              <div class="w-40">
                <div class="c-radio--separated">
                  <span class="c-radio-button">
                    <input type="radio" name="tad_additional_securities_display" formControlName="tad_additional_securities_display" [checked]="_showAction == false" id="tad_no" value="false">
                    <label class="c-radio-button__label" for="tad_no">
                      <span class="c-radio-button__faux">No</span>
                      <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                    </label>
                  </span>
                </div>
              </div>
              <div class="w-20 text-right">
                <together-auction-dip-tooltip [placement]="'top'" [title]="'This could help increase the maximum loan to value (LTV) we can offer.'"></together-auction-dip-tooltip>
              </div>
            </div>
            <together-auction-dip-validate-fields [displayError]="additionalLoanDetailsForm.get('tad_additional_securities_display').hasError('required') && isAdditionalSecuritySelected" errorMsg="This field is required to continue"></together-auction-dip-validate-fields>
          </div>
        </div>
      </fieldset>
      @if (_showAction) {
        <div>
          @for (security of securities; track security) {
            <together-auction-dip-additional-details-security [do_save]="_do_save" [incoming_case_id]="incoming_case_id" (form_out)="_handleSecurityForm($event)" [security]="security" (has_saved)="handleSave($event)" [parentFormGroup]="additionalLoanDetailsForm"
              (is_loading)="_handleLoading($event)">
            </together-auction-dip-additional-details-security>
          }
        </div>
      }
    </form>
    <!-- <pre><code>{{additionalLoanDetailsForm.value | json}}</code></pre> -->
    <together-auction-dip-stage-select [show_action]="false" [show_forward]="_showForward" [show_backward]="showBackward()" [backward_disabled]="false" [forward_title]="_forwardText" [backward_title]="showAction() ? 'Property details': ''" (on_forward)="_handleForward()"
      (on_backward)="_handleBackWard()">
    </together-auction-dip-stage-select>
    <together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
